/* This file includes all apps and extensions for different operating systmes and browsers */

module.exports = {
  APP_STORE: 'http://ecosia.co/mobile_ft_ios',
  CHROME_EXTENSION: 'https://chrome.google.com/webstore/detail/ecosia-the-search-engine/eedlgdlajadkbbjoobobefphmfkcchfk',
  EDGE_EXTENSION: 'https://microsoftedge.microsoft.com/addons/detail/ecosia-the-search-engin/fhfidmlnclkepgapcephbaciajegheco',
  EDGE_INSTALL_INSTRUCTIONS: 'https://ecosia.helpscoutdocs.com/article/346-install-the-ecosia-browser-extension',
  FIREFOX_EXTENSION: 'https://addons.mozilla.org/firefox/downloads/latest/ecosia-the-green-search',
  FIREFOX_LEGACY_EXTENSION: 'https://addons.mozilla.org/firefox/downloads/file/519186/ecosia_the_search_engine_that_plants_trees-3.4.5-fx.xpi',
  SAFARI_SET_AS_DEFAULT: 'https://blog.ecosia.org/how-to-use-ecosia-mac-safari-firefox-edge-chrome/#ecosia-on-safari',
  OPEN_SEARCH: 'https://www.ecosia.org/opensearch.xml',
  PLAY_STORE: 'https://play.google.com/store/apps/details?id=com.ecosia.android',
  SAFARI_LEGACY_EXTENSION: 'https://safari-extensions.apple.com/details/?id=org.ecosia.main-33YMRSYD2L',
  SAFARI_SET_AS_HOMEPAGE_INSTRUCTIONS: 'https://ecosia.helpscoutdocs.com/article/348-set-ecosia-as-your-browser-homepage',
};
